import IRccDetails from '../models/IRccDetails';

const BLOCKED_CASH_APP_NUMBERS = ['041215663', '073923033'];

const isCashAppRoutingNumber = (routingNumber: string) => {
  return BLOCKED_CASH_APP_NUMBERS.some((blockedNumber) => routingNumber === blockedNumber);
};

export const handleRoutingNumValidationError = (routingNumber: string) => {
  return isCashAppRoutingNumber(routingNumber)
    ? 'The bank associated with this routing number is not supported. Please try again with a different bank.'
    : '';
};

export const validateRccDetails = (rccDetails: IRccDetails) => {
  return (
    rccDetails.routingNumber &&
    !isCashAppRoutingNumber(rccDetails.routingNumber) &&
    rccDetails.accountNumber &&
    rccDetails.routingNumber.length === 9 &&
    rccDetails.accountNumber.length <= 17
  );
};
